import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface CenteredLayoutProps {
  className?: string;
  children: ReactNode;
}

/** Centered fixed width page layout container. */
export const PageCenteredLayout: FC<CenteredLayoutProps> = (props) => {
  return (
    <div
      className={twMerge(
        `mx-auto flex max-w-4xl flex-col gap-y-6 px-4 py-8 sm:px-6`,
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};
